/**
 * Shared keys for the patient-edit top-level tab strip.
 *
 * Both `PatientEditPage` (which owns the strip) and `ChartTabBody` (which
 * cross-links to the Appointments tab from its inner Appointments
 * placeholder) consume these so a rename here propagates atomically.
 *
 * Inner-tab keys for the Chart shell live alongside `ChartTabBody` —
 * different scope, different lifetime.
 */

export const PATIENT_EDIT_TAB_KEYS = [
  // Patient pages switch (`?x=patient-pages`) only: the Overview hub, first and the landing tab.
  'overview',
  'personal-details',
  'contact-details',
  'chart',
  'community',
  'billing',
  'appointments',
  // Patient pages switch only: the care plan with its Progress view, last as in the design's record tabs.
  'care-plan',
] as const;

export type PatientEditTabKey = (typeof PATIENT_EDIT_TAB_KEYS)[number];

/** Query-string keys this tab strip writes / reads. */
export const PATIENT_EDIT_TAB_PARAM = 'tab';

/** Chart-shell-only query-string key — scoped to `?tab=chart`. We strip
 *  it from the URL when switching away from Chart so that re-entry
 *  defaults to the canonical inner tab instead of whatever was last set. */
export const CHART_INNER_PARAM = 'inner';

/** The tabbed chart's own tab, in the URL so Back and refresh keep it (`?tab=chart&chartTab=documents`). Stripped with
 *  `inner` when the record switches to another top-level tab. The old `inner` links still open the tab that holds the section. */
export const CHART_TAB_PARAM = 'chartTab';
